import { useSelector } from 'react-redux';
import { useIsFeatureEnabled } from '../../../features/feature-enablement/featureEnablement';
import {
  approvalWorkflowsFeatureSelector,
  labelsFeatureSelector,
} from '../../../features/pricing/selectors';
import {
  externalStoresEnabledSelector,
  organizationGroupSelector,
} from '../../../redux/modules/organizationGroup/selectors';

export const useAccessibleFeatures = () => {
  const orgGroupFeatures =
    useSelector(organizationGroupSelector)?.features ?? {};

  const isLabelsEnabled = useSelector(labelsFeatureSelector);

  const isExternalStoresEnabled = useSelector(externalStoresEnabledSelector);

  const isRuleManagerEnabled = useIsFeatureEnabled('rule-manager');

  const isCredentialsEnabled = useIsFeatureEnabled('integration-credentials');

  const isWorkflowsEnabled = useSelector(approvalWorkflowsFeatureSelector);

  return {
    features: {
      isLabelsEnabled,
      isDatasetsEnabled: orgGroupFeatures.datasets?.enabled,
      isExternalStoresEnabled,
      isRuleManagerEnabled,
      isCredentialsEnabled,
      isWorkflowsEnabled,
    },
  };
};
